'use client';

import ReactDOM from 'react-dom';

export default function PostPreconnect() {
  // Preconnect к CDN с картинками блога
  ReactDOM.preconnect('https://dogsblog-20f98.kxcdn.com', {
    crossOrigin: 'anonymous'
  });

  // DNS-prefetch для того же хоста
  ReactDOM.prefetchDNS('https://dogsblog-20f98.kxcdn.com');

  return null;
}
